import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import classNames from 'classnames'

const styleSheet = {
    portraitIcon: {
        width: 50,
        height: 85,
        margin: '25px auto',
        border: '1px solid #fff',
        borderBottom: '7px solid #fff',
        borderRadius: 5,
    },
}

const style = injectJss(styleSheet)

const PortraitIcon = ({ classes, className }) => <div className={classNames(classes.portraitIcon, className)} />

export default compose(
    style,
    pure
)(PortraitIcon)
